/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */

import React, {
  useContext,
  useCallback,
  useEffect,
  useState,
  Fragment
} from 'react';
import { t } from 'ttag';

import { Dialog, Transition } from '@headlessui/react';

import { mergeClasses } from '@utils';

// eslint-disable-next-line import/no-cycle
import { HeaderContext } from '../../Header';

export default function TinyBanner() {
  const { hideTinyBanner, tinyBanner } = useContext(HeaderContext);

  const [isTBHidden, setIsTBHidden] = useState(hideTinyBanner);

  const [isOpen, setIsOpen] = useState(false);

  const handleClose = useCallback(() => {
    setIsTBHidden(true);

    // This removes the Padding added for the TinyBanner during SSR, and sets it to the default value (the height of the Header).
    document.body.classList.remove('pt-[112px]');
    document.body.style.paddingTop = '64px';

    // Hide the TinyBanner for the current Session.
    fetch('/api/banners/hide/', {
      method: 'POST'
    }).then(() => {
      // Do nothing.
    });
  }, []);

  useEffect(() => {
    setIsTBHidden(hideTinyBanner);
  }, [hideTinyBanner]);

  if (isTBHidden || !tinyBanner) return null;

  return (
    <>
      <div
        className={mergeClasses(
          'relative z-[5000] flex h-12 w-full items-center justify-between gap-2 overflow-hidden px-4 text-center text-sm text-black hover:cursor-pointer lg:justify-center'
        )}
        style={{
          backgroundImage: tinyBanner?.background_gradient
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="inline-block max-h-full text-left font-semibold leading-tight">
          <p
            className="line-clamp-2 lg:line-clamp-1"
            style={{
              color: tinyBanner?.title_color
            }}
          >
            {tinyBanner.title}
          </p>
        </div>
        <button
          type="button"
          className="flex w-fit cursor-pointer items-center justify-between gap-x-1 border-0 bg-transparent p-4 leading-none text-black no-underline antialiased outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 lg:absolute lg:inset-y-0 lg:right-0"
          aria-label={t`Close`}
          onClick={() => handleClose()}
          style={{
            color: tinyBanner?.title_color
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4 shrink-0"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
      <Transition show={isOpen} as={Fragment}>
        <Dialog className="relative" onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 z-20 bg-black/30 backdrop-blur-sm" />
          </Transition.Child>
          <Dialog.Panel className="fixed inset-x-0 top-[112px] z-20 max-h-screen">
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-200"
              enterFrom="transform-gpu -translate-y-full"
              enterTo="transform-gpu translate-y-0"
              leave="ease-in-out duration-200"
              leaveFrom="transform-gpu translate-y-0"
              leaveTo="transform-gpu -translate-y-full"
            >
              <div
                className="relative h-fit w-full space-y-8 px-4 py-8 lg:flex lg:items-start  lg:gap-32 lg:space-y-0 lg:px-12 lg:py-12 xl:gap-64"
                style={{
                  backgroundImage: tinyBanner?.background_gradient
                }}
              >
                <span
                  className="text-3xl font-extrabold uppercase leading-none tracking-tight lg:w-96 lg:text-4xl"
                  style={{
                    color: tinyBanner?.title_color
                  }}
                >
                  {tinyBanner?.subtitle}
                </span>
                <div className="grid grow grid-cols-1 gap-4 lg:grid-cols-2">
                  {tinyBanner?.links?.[0]?.value?.map(({ label, url }) => (
                    <a
                      key={url}
                      href={url}
                      className="text-2xl font-bold outline-none focus:outline-none"
                      style={{
                        color: tinyBanner?.title_color
                      }}
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </div>
            </Transition.Child>
          </Dialog.Panel>
        </Dialog>
      </Transition>
    </>
  );
}
